<template>
  <div>
    <b-tooltip :target="`${type}-add-btn-${identifier}`" :title="$t(`Add {type}`, {type: childName})"/>
    <b-button
        v-if="!excludeActions.includes(SALES_TAX_ADD_ACTION)" :id="`${type}-add-btn-${identifier}`" variant="primary"
        size="sm" class="mr-2" :disabled="disableActions.includes(SALES_TAX_ADD_ACTION)" @click="onAddClick">
      <font-awesome-icon icon="plus"/>
    </b-button>
    <b-tooltip :target="`${type}-edit-btn-${identifier}`" :title="$t(`Edit {type}`, {type: type})"/>
    <b-button
        v-if="!excludeActions.includes(SALES_TAX_EDIT_ACTION)" :id="`${type}-edit-btn-${identifier}`" variant="primary"
        size="sm" class="mr-2" :disabled="disableActions.includes(SALES_TAX_EDIT_ACTION)" @click="onEditClick">
      <font-awesome-icon icon="pen"/>
    </b-button>
    <b-tooltip :target="`${type}-view-details-btn-${identifier}`" :title="$t(`View {type} Details`, {type: type})"/>
    <b-button
        v-if="!excludeActions.includes(SALES_TAX_VIEW_DETAILS_ACTION)" :id="`${type}-view-details-btn-${identifier}`"
        variant="primary" size="sm" class="mr-2" :disabled="disableActions.includes(SALES_TAX_VIEW_DETAILS_ACTION)"
        @click="onViewDetailsClick">
      <font-awesome-icon icon="eye" class="icon"/>
    </b-button>
    <b-tooltip :target="`${type}-delete-btn-${identifier}`" :title="$t(`Delete {type}`, {type: type})"/>
    <b-button
        v-if="!excludeActions.includes(SALES_TAX_DELETE_ACTION)" :id="`${type}-delete-btn-${identifier}`"
        variant="danger" size="sm" class="mr-2" :disabled="disableActions.includes(SALES_TAX_DELETE_ACTION)"
        @click="onDeleteClick">
      <font-awesome-icon icon="trash"/>
    </b-button>
  </div>
</template>

<script>
  import {
    SALES_TAX_ADD_ACTION,
    SALES_TAX_DELETE_ACTION,
    SALES_TAX_EDIT_ACTION,
    SALES_TAX_VIEW_DETAILS_ACTION
  } from "../../../constants";

  export default {
    name: "SalesTaxActionButtons",
    props: {
      type: {
        type: String,
        default: 'State',
        required: true,
      },
      object: {
        type: Object,
        required: true,
      },
      childName: {
        type: String,
      },
      excludeActions: {
        type: Array,
        default: () => [],
      },
      disableActions: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        SALES_TAX_ADD_ACTION: SALES_TAX_ADD_ACTION,
        SALES_TAX_EDIT_ACTION: SALES_TAX_EDIT_ACTION,
        SALES_TAX_VIEW_DETAILS_ACTION: SALES_TAX_VIEW_DETAILS_ACTION,
        SALES_TAX_DELETE_ACTION: SALES_TAX_DELETE_ACTION,
      }
    },
    computed: {
      identifier() {
        return this.object.uuid;
      },
    },
    methods: {
      onAddClick() {
        this.$emit('onAddClick', this.object);
      },
      onEditClick() {
        this.$emit('onEditClick', this.object);
      },
      onViewDetailsClick() {
        this.$emit('onViewDetailsClick', this.identifier);
      },
      onDeleteClick() {
        this.$emit('onDeleteClick', this.object);
      },
    }
  }
</script>

<style scoped>

</style>